import { render, staticRenderFns } from "./selectPBBrandClear.vue?vue&type=template&id=2a614020"
import script from "./selectPBBrandClear.vue?vue&type=script&lang=js"
export * from "./selectPBBrandClear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports